import { render } from "./WaybillTable.vue?vue&type=template&id=26977b7a"
import script from "./WaybillTable.vue?vue&type=script&lang=js"
export * from "./WaybillTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__